import api from "@/api/user.js";
import {getToken, setToken} from '@/libs/util'
import {clientId} from '@/http/config'

const user = {
    state: {
        token: '',
        refresh_token: "",
        userInfo: {},
        menus: [],
        btns: []
    },
    mutations: {
        // SET_TOKEN: (state, { access_token, refresh_token}) => {
        //     state.token = access_token;
        //     state.refresh_token = refresh_token
        // },
        SET_TOKEN: (state, access_token) => {
            state.token = access_token
        },
        SET_REFRESH_TOKEN: (state, refresh_token) => {
            state.refresh_token = refresh_token
        },
        SET_USERINFO: (state, userInfo) => {
            state.userInfo = userInfo
        },
        SET_MENUS: (state, menus) => {
          state.menus = menus
        },
        SET_BTNS: (state, btns) => {
          state.btns = btns
        }
    },
    actions: {
        async Login({ commit }, userInfo) {
            try {
                const res = await api.login(userInfo);
                if (userInfo.setToken) {
                    commit('SET_TOKEN', res.access_token)
                    commit('SET_REFRESH_TOKEN', res.refresh_token)
                }
                return res;
            } catch (err) {
                return err;
            }
        },
        async GetUserInfo({ commit }, params) {
            try {
                const res = await api.getUserInfo(params);
                res["employee"] = await api.getEmployeeInfo({
                    ...params,
                    userId: res.id
                });
                commit('SET_USERINFO', res["employee"]);
                return res;
            } catch (err) {
                return err;
            }
        },
        async GetMenus({ commit }) {
            try {
              let param = { resType: 1, clientId: clientId }
                const res = await api.getMenu(param);
                // console.log(res)
                if (!res) return []
                let appMenu = res.filter((item) => {
                  return item.raw.name == 'app'
                })
                if (appMenu.length) {
                  commit('SET_MENUS', appMenu[0].children)
                } else {
                  commit('SET_MENUS', [])
                }
                return res;
            } catch (err) {
                return err;
            }
        },
        async GetBtnResources({ commit }) {
            try {
              let param = { resType: 2, clientId: clientId }
                const res = await api.getBtnResources(param);
                if (!res) return []
                let appBtns = res.filter((item) => {
                  return item.code.startsWith('a')
                })
                if (appBtns.length) {
                  commit('SET_BTNS', appBtns)
                }
                return res;
            } catch (err) {
                return err;
            }
        }
    }
};

export default user;
